<template>
  <b-col lg="6" class="mb-3 d-flex gap-2">
    <div class="d-flex mr-2" style="min-width: 250px">
      <v-multiselect
        v-model="filters.vehicle"
        :options="vehicleList"
        :multiple="true"
        :close-on-select="false"
        label="name"
        track-by="id"
        placeholder="Select Vehicle"
        class="w-100"
      ></v-multiselect>
    </div>
    <date-picker
      v-model="filters.month"
      type="month"
      format="MMMM YYYY"
      style="width: 240px"
    />
  </b-col>
</template>

<script>
import { fleetsActions } from '@/src/Utils/helper'

export default {
  name: 'FilterRh',
  props: {
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      vehicleList: [],
    }
  },
  methods: {
    ...fleetsActions,
    async getVehicleData() {
      try {
        const res = await this.getFleets({
          page: 1,
          perPage: 9999,
          showAll: true,
        })
        if (res.status === 'success' && Array.isArray(res.data)) {
          this.vehicleList = res.data.filter((item) => item.active)
        }
      } catch (error) {
        console.log('Error fetching vehicles:', error)
      }
    },
  },
  mounted() {
    this.getVehicleData()
  },
}
</script>
